module.exports = __webpack_public_path__ + "static/media/atharva.59fda011.png";